import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { StudyBundleCourseDto } from '../../../shared/types/StudyBundleCourseDto';
import { StudyBundleCourseStatusType } from '../../../shared/types/StudyBundleCourseStatusType';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../../shared/types/CarouselSettings';

@Component({
  selector: 'lp2-mini-lesson-carousel',
  templateUrl: './mini-lesson-carousel.component.html',
  styleUrls: ['./mini-lesson-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniLessonCarouselComponent implements OnInit {
  @Input() lessons: StudyBundleCourseDto[];

  carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  currentLessonIndex: number = null;

  constructor() {}

  ngOnInit() {
      for (const lesson of this.lessons) {
        if (
          this.currentLessonIndex === null &&
          (lesson.status === StudyBundleCourseStatusType.NOT_STARTED ||
            lesson.status === StudyBundleCourseStatusType.IN_PROGRESS)
        ) {
          this.currentLessonIndex = this.lessons.indexOf(lesson);
          this.carouselSettings.startPosition = this.currentLessonIndex;
        }
      }

      if (this.currentLessonIndex === null) {
        this.currentLessonIndex = 0;
      }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-carousel/mini-lesson-carousel.component.ts